/*
 * @@Author: MuYang
 */

// 数组转对象
export function arrayToObj (data, key = 'apiName') {
  if (!Array.isArray(data)) {
    return []
  }
  const maps = {}
  let item
  for (let i = 0; i < data.length; i++) {
    item = data[i]
    if (maps[item[key]]) {
      console.log(key)
    }
    maps[item[key]] = item
  }
  return maps
}

// 判断端
export const projectInfo = {
  query () {
    return window.fe?.apaas?.biz?.project
  },
  include (str) {
    return this.query() === str
  }
}